<div class="container-fluid d-flex justify-content-center flex-wrap bg-alag-blue" >
    <div class="col-12 p-3 text-white text-center">
        <div class="font-inter-bold">
            Swap Bitssa
        </div>
        <div class="font-inter-light">
            Convert stablecoin to currency hassle free
        </div>
    </div>
    <div class="d-flex flex-wrap w-100 py-5 mb-0 mb-md-5 height-fit-content">
        <div class="col-12 col-md-6 d-flex flex-column align-items-center align-items-md-end height-fit-content">
            <div class="d-flex col-12 col-md-6 flex-column custom-calc p-2 px-4 m-2 border">
                <div class="font-inter-bold text-white" style="font-size: 24px !important;">Source amount</div>
                <div class="input-group mb-3">
                    <input type="number" class="form-control rounded bg-light border-0 p-4" placeholder="Source amount" aria-label="Source amount" aria-describedby="basic-addon2" [(ngModel)]="sourceAmount" (input)="changeDestinationAmount()">
                    <button type="button" class="btn text-dark bg-transparent dropdown-toggle rounded text-left position-absolute h-100" style="right:0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img [src]="titleUrl"  class="mx-2" style="width:16px !important">
                        {{title}} &nbsp;&nbsp;
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" *ngFor="let source of sources" (click)="selectSource(source.name, source.image.url)">
                            <img [src]="source.image?.url"  [alt]="source.name" class="mx-2" style="width:16px !important">
                            {{source.name}}
                        </a>
                    </div>
                </div>
            </div>  
            <div class="d-flex col-12 col-md-6 flex-column custom-calc p-2 px-4 m-2 border">
                <div class="font-inter-bold text-white" style="font-size: 24px !important;">Destination amount</div>
                <div class="input-group mb-3 position-relative">
                    <input type="number" class="form-control rounded bg-light border-0 p-4" placeholder="Destination amount" aria-label="Destination amount" aria-describedby="basic-addon2" [(ngModel)]="convertedAmount" readonly>
        
                    <button type="button" class="btn text-dark bg-transparent dropdown-toggle rounded text-left position-absolute h-100" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="right:0">
                        <img [src]="title1Url"  class="mx-2" style="width:16px !important">
                        {{title1}} &nbsp;&nbsp;
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" *ngFor="let destination of destinations" (click)="selectDestination(destination.name, destination.image.url)">
                            <img [src]="destination.image?.url"  [alt]="destination.name" class="mx-2" style="width:16px !important">
                            {{destination.name}}
                        </a>
                    </div>
                </div>
            </div>  
        </div>
        <div class="col-12 col-md-6 d-flex align-items-center">
            <div class="col-1 d-none d-md-flex justify-content-center">
                <div class="d-flex flex-column justify-content-around">
                    <img src="../../assets/images/vertical_line_circle.png" alt="">
                    <img src="../../assets/images/vertical_line_circle.png" alt="">
                </div>
                <div style="margin-left: -9px;">
                    <img src="../../assets/images/vertical_line.png" alt="">
                    
                </div>
            </div>
            <div class="col-11 d-flex flex-column align-items-center align-items-md-start justify-content-center">
                <div class="col-8 col-md-5 flex-column custom-calc m-3 p-3 border">
                    <div class="font-inter-bold text-white text-center m-2 mb-3" style="font-size: 24px !important;line-height: 24px;">
                        Fees charged
                    </div>
                    <div class="text-center text-white font-inter-med m-2 mt-3">
                        {{fees}} <span class="text-primary">{{source}}</span>
                    </div>
                </div>
                <div class="col-8 col-md-5 flex-column custom-calc m-3 p-3 border">
                    <div class="font-inter-bold text-white text-center m-2 mb-3" style="font-size: 24px !important;line-height: 24px;">
                        Conversion rate
                    </div>
                    <div class="text-center text-white font-inter-med m-2 mt-3">
                        1 <span class="text-primary">{{source}}</span> =  {{conversionRate}} <span class="text-primary">{{destination}}</span>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
    <!-- <div class="col-12 col-md-4 d-flex align-items-center flex-wrap justify-content-center">
        <h1 class="text-center d-flex flex-wrap justify-content-left text-white px-5">
            <span class="py-1 h1 w-100 text-left">Stable coins to Fiat.</span>
            <span class="py-1 h2 w-100 text-left" style="font-weight: 100;">Made Easy!</span>
            <button class="btn btn-outline-light px-5 py-1" data-toggle="modal" data-target="#loginRegisterModal">
                Go to App!
            </button>
        </h1>
    </div> -->
</div>
<div class="container-fluid d-flex justify-content-center flex-wrap py-5 bg-navy-blue">
    <div class="col-12 p-3 text-center">
        <div class="text-white font-inter-bold">
            Coins we support
        </div>
    </div>
    <div class="col-10 p-3 d-flex justify-content-center flex-wrap">
        <div *ngFor="let source of sources" class="p-3 text-center col-12 col-md-2">
            <img [src]="source.image?.url" alt="" width="120">
        </div>
        
    </div>
</div>
<div class="container-fluid d-flex justify-content-center flex-wrap py-5 bg-light-gray">
    <div class="col-12 p-3 text-center">
        <div class="text-alag-blue font-inter-bold">
            Bitssa is simple
        </div>
    </div>
    <div class="col-12 py-5 d-flex justify-content-center flex-wrap">
        <div class="col-12 col-md-3 p-3 d-flex flex-column">
            <div class="text-center">
                <!-- <img src="../../assets/images/homepage_1.png" alt=""> -->
                <h1 class="text-blue-number font-inter-bold">1</h1>
            </div>
            <!-- <div class="col-12 text-center font-weight-bold">Manage portfolio</div> -->
            <div class="text-center py-2 text-light-gray font-inter-med">Logon or Register</div>
        </div>
        <div class="col-12 col-md-3 p-3 d-flex flex-column">
            <div class="text-center">
                <!-- <img src="../../assets/images/homepage_2.png" alt=""> -->
                <h1 class="text-blue-number font-inter-bold">2</h1>
            </div>
            <!-- <div class="col-12 text-center font-weight-bold">Protected securely</div> -->
            <div class="text-center py-2 text-light-gray font-inter-med">Choose Currency Pair & Connect Wallet</div>
        </div>
        <div class="col-12 col-md-3 p-3 d-flex flex-column">
            <div class="text-center">
                <!-- <img src="../../assets/images/homepage_3.png" alt=""> -->
                <h1 class="text-blue-number font-inter-bold">3</h1>
            </div>
            <!-- <div class="col-12 text-center font-weight-bold">Currency variety</div> -->
            <div class="text-center py-2 text-light-gray font-inter-med">Select or add your Beneficiary</div>
        </div>
        <div class="col-12 col-md-3 p-3 d-flex flex-column">
            <div class="text-center">
                <!-- <img src="../../assets/images/homepage_4.png" alt=""> -->
                <h1 class="text-blue-number font-inter-bold">4</h1>
            </div>
            <!-- <div class="col-12 text-center font-weight-bold">Learn best practices</div> -->
            <div class="text-center py-2 text-light-gray font-inter-med">Swap and send to your Beneficiary</div>
        </div>
    </div>
</div>
<div class="container-fluid d-flex justify-content-center flex-wrap py-5 bg-white position-relative">
    <div class="col-12 p-3 text-center">
        <h2 class="text-blue font-inter-bold">
            Payout currencies
        </h2>
    </div>
    
    <div class="col-10 p-3 d-flex justify-content-between" >
        <div class="d-flex align-items-center col-1 justify-content-center" (click)="prev()" [ngClass]="{'cursor-pointer': i-destination_carousel_length>=0}">
            <img src="../../assets/images/left_arrow.png" alt="" >
        </div>
    
        <div *ngFor="let destination of destinationsToBeShown" class="col-10 col-md-3 p-3 mx-2 d-flex flex-wrap justify-content-center currency-box position-relative mt-5">
            <img [src]="destination.image?.url" alt="" height="90" class="position-absolute" style="top:-40%">
            <span class="w-100 text-center my-2 font-inter-bold" style="font-size: 48px;">{{destination.country}}</span>
            <span class="w-100 text-center text-secondary font-inter-med">{{destination.name}}</span>
        </div>
    
        <div class="d-flex align-items-center col-1 justify-content-center" (click)="next()" [ngClass]="{'cursor-pointer': +i+destination_carousel_length<destinations.length}">
            <img src="../../assets/images/right_arrow.png" alt="">
        </div>
    </div>
    
</div>
<!-- <app-login-register-modal></app-login-register-modal> -->


